import { render } from "./Balita.vue?vue&type=template&id=38c91c38"
import script from "./Balita.vue?vue&type=script&lang=js"
export * from "./Balita.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__